import React, { useMemo, useState } from 'react';
import './VersionFooter.css';

function readBuildInfo() {
  const fromWindow = typeof window !== 'undefined' ? window : {};
  return {
    version: process.env.REACT_APP_BUILD_VERSION || fromWindow.__APP_VERSION__ || 'v0.0.0-dev.unknown',
    epoch: Number(process.env.REACT_APP_BUILD_EPOCH || fromWindow.__APP_EPOCH__ || 0),
    branch: process.env.REACT_APP_BUILD_BRANCH || fromWindow.__APP_BRANCH__ || 'dev',
  };
}

export function formatRelative(timestamp, now = Date.now()) {
  const seconds = Math.floor((now - timestamp) / 1000);
  if (seconds < 60) return 'moments ago';
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
  if (seconds < 604800) return `${Math.floor(seconds / 86400)}d ago`;
  return `${Math.floor(seconds / 604800)}w ago`;
}

const VersionFooter = () => {
  const [mode, setMode] = useState('full');
  const info = useMemo(() => readBuildInfo(), []);

  const relativeLabel = `${formatRelative(info.epoch)} ${info.branch}`;
  const label = mode === 'relative' ? relativeLabel : info.version;
  const title = mode === 'full'
    ? `${relativeLabel} (click to toggle)`
    : info.version;

  return (
    <button
      type="button"
      className="version-footer"
      onClick={() => setMode((current) => (current === 'full' ? 'relative' : 'full'))}
      title={title}
      aria-label="Build version"
    >
      {label}
    </button>
  );
};

export default VersionFooter;
